// extracted by mini-css-extract-plugin
module.exports = {"visual":"ShopImages_visual__I_maX","selected":"ShopImages_selected__LRywe","carousel_photo":"ShopImages_carousel_photo__V4a21","carousel_video":"ShopImages_carousel_video__iTqzv"};